export interface TableRow {
  header: string;
  contents: string;
}

export interface TableCardArgs {
  headerText?: string;
  tableData: TableRow[];
}
